export default __webpack_public_path__ + "media/images/house-image-fc556cc0178fb05213223b4c237c4272.png";